import * as React from 'react';
import * as types from 'modules/types/smSupplierManagement';
import _ from 'lodash';
import { Form, Card } from '@beehive/components';
import { SERVICE_INFO_KEYS } from '../utils';
import { renderForm, HandleChagneParams, CustomFormKeys } from '../Edit/BasicInfo';
import { EditType } from '../Edit/supplierEditHOC';
import PropTypes from 'prop-types';
import messages from 'messages/CompanyManagement';

const FORM_KEYS = Object.keys(SERVICE_INFO_KEYS).map((key: string) => SERVICE_INFO_KEYS[key].editProps.formKey);

export interface ServiceInfoProps {
  data: types.SupplierMangementDetail;
  onChange: any;
  editType?: EditType;
  customFormKeys?: CustomFormKeys;
  showError?: boolean;
}

class ServiceInfo extends React.Component<ServiceInfoProps, any> {

  public static contextTypes = {
    intl: PropTypes.object,
  };

  public static defaultProps: Partial<ServiceInfoProps> = {
    customFormKeys: SERVICE_INFO_KEYS,
  };

  private formRef: React.RefObject<typeof Form>;

  constructor(props: ServiceInfoProps) {
    super(props);
    this.formRef = React.createRef();
  }

  public shouldComponentUpdate(nextProps: ServiceInfoProps) {
    if (this.props.showError !== nextProps.showError) {
      return true;
    }
    const pickKeys = [...FORM_KEYS, 'detailError.messages', 'loading', 'loaded', 'change_detail'];
    const thisData = _.pick(this.props.data, pickKeys);
    const nextData = _.pick(nextProps.data, pickKeys);
    if (_.isEqual(thisData, nextData)) {
      return false;
    }
    return true;
  }

  // 修改内容
  private handleChange = (params: HandleChagneParams) => {
    const { onChange, data, data: { change_detail = {} } } = this.props;
    const { key, value } = params;
    const newData = _.cloneDeep(data);
    const formKey = SERVICE_INFO_KEYS[key].editProps.formKey;
    // 注意`service_info.total_employee`是一个整体，直接get会拿不到值
    const error = _.get(_.get(data, `detailError.messages`), formKey);
    const newDetailError = _.cloneDeep(data.detailError);
    if (error) {
      delete newDetailError.messages[formKey];
    }

    if (key !== 'supplier_resources') {
      Object.assign(newData, {
        detailError: { ...newDetailError },
        change_detail: {
          ...change_detail,
          service_info: {
            ..._.get(change_detail, 'service_info', {}),
            [key]: value,
          },
        },
      });
      onChange(newData);
    } else {
      const val: any[] = this.handleChangeSupplierResources(params);
      Object.assign(newData, {
        detailError: { ...newDetailError },
        change_detail: {
          ...change_detail,
          [key]: [
            ...val,
          ],
        },
      });
      onChange(newData);
    }
  }

  // 优势资源平台是树形结构, 并且可以删除，需要特殊处理
  private handleChangeSupplierResources = (params: HandleChagneParams) => {
    const { data } = this.props;
    const { value, key } = params;
    const formKey = SERVICE_INFO_KEYS[key].editProps.formKey;
    const supplierResources = _.get(data, formKey, []);
    const supplierResourcesMapping = supplierResources.reduce((acc: any, cur: any) => {
      acc[cur.superior_resource_id] = cur;
      return acc;
    }, {});

    if (Array.isArray(value)) {
      const newValue = value.map((i: number) => {
        if (supplierResourcesMapping[i]) {
          return { ...supplierResourcesMapping[i], _destroy: false };
        } else {
          return {
            superior_resource_id: i,
            supplier_id: data.id,
          };
        }
      });
      const destroyedValue = supplierResources.reduce((acc: any, cur: any) => {
        if (cur.id && !~value.indexOf(cur.superior_resource_id)) {
          acc.push({
            ...cur,
            _destroy: true,
          });
        }
        return acc;
      }, []);
      return newValue.concat(destroyedValue);
    }
    return [];
  }

  public isFormValid = (): boolean => {
    if (this.formRef.current) {
      return this.formRef.current.valid();
    }
    return true;
  }

  public render() {
    const { intl } = this.context;
    const { data, customFormKeys = {}, showError } = this.props;
    const { options, loading, change_detail = {} } = data;
    const errorMsg = _.pick(_.get(data, 'detailError.messages'), FORM_KEYS);
    const changedData = _.get(change_detail, 'service_info', {});
    const changedResourcesData: any[] = _.get(change_detail, 'supplier_resources', []);
    return (
      <Card
        titleNode={intl.formatMessage(messages.serviceInfo)}
        loading={loading}
        className="service-info"
      >
        <Form isLabelVertical errorMsg={errorMsg} showError={showError} mode="edit" ref={this.formRef} showClientError>
          {
            Object.keys(customFormKeys).map((key: string, idx: number) => {
              const item = SERVICE_INFO_KEYS[key];
              const label = intl.formatMessage(messages[key]);
              let value = _.get(data, `${item.editProps.formKey}`);
              if (key in changedData) {
                value = changedData[key];
              }
              if (key === 'supplier_resources') {
                value = !!changedResourcesData.length ? changedResourcesData : _.get(data, `${item.editProps.formKey}`);
              }
              const editProps = item.editProps || {};
              if (editProps.getValue) {
                value = editProps.getValue(value);
              }
              return (
                <Form.Item
                  label={label}
                  required={!!item.required}
                  key={key}
                  itemKey={`service_info.${key}`}
                  {...editProps}
                >
                  {renderForm({ key, value, options, data: SERVICE_INFO_KEYS, handleChange: this.handleChange })}
                </Form.Item>
              );
            })
          }
        </Form>
      </Card>
    );
  }
}

export default ServiceInfo;
